<ngx-zero-state class="zero-state-data-source-empty" *ngIf="(archivedListDataSource.loading$ | async) === false; else loading">
    <h1 zero-state-title translate="archive-zero-state_title"></h1>

    <div zero-state-body translate="archive-zero-state_description"></div>
</ngx-zero-state>

<ng-template #loading>
	<section class="loading-state">
		<loading></loading>
	</section>
</ng-template>
